export class CoreIds {
    datasourceId: number;
    seriesId: number;
    periodId: number;
    productId: number;
    customerId: number;
    datasourceMappingId: number;
}
